import { render, staticRenderFns } from "./SwitchToggle.vue?vue&type=template&id=42fdea76&scoped=true&"
import script from "./SwitchToggle.vue?vue&type=script&lang=js&"
export * from "./SwitchToggle.vue?vue&type=script&lang=js&"
import style0 from "./SwitchToggle.vue?vue&type=style&index=0&id=42fdea76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fdea76",
  null
  
)

export default component.exports